module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "runnability"
  }, [_c('Vueheader', {
    attrs: {
      "addActive": _vm.addActive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "allLedger"
  }, [_c('div', {
    staticClass: "ledger active",
    on: {
      "click": _vm.statistics
    }
  }, [_c('span', {
    staticClass: "iconfont icon-ren111"
  }, [_vm._v("总推荐人")])]), _vm._v(" "), _c('div', {
    staticClass: "ledger",
    staticStyle: {
      "margin": "0 3.5%"
    },
    on: {
      "click": function($event) {
        return _vm.statistics('mount')
      }
    }
  }, [_c('span', {
    staticClass: "iconfont icon-renqun"
  }, [_vm._v("总上岗人数")])]), _vm._v(" "), _c('div', {
    staticClass: "ledger",
    on: {
      "click": function($event) {
        return _vm.statistics('duration')
      }
    }
  }, [_c('span', {
    staticClass: "iconfont icon-shijian00"
  }, [_vm._v("总服务时长")])])]), _vm._v(" "), _c('vue-highcharts', {
    ref: "lineCharts",
    attrs: {
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "rightcenter"
  }, [_c('img', {
    staticClass: "sharebg",
    attrs: {
      "src": "static/img/sharebg.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rightTxt"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "static/img/logo.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logotxt",
    attrs: {
      "src": "static/img/logotxt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "logotext"
  }, [_vm._v("在家做客服，在家赚钱")]), _vm._v(" "), _c('p', {
    staticClass: "wenben"
  }, [_vm._v("从零开始，邀请您进入在家赚钱的淘金云客服平台")]), _vm._v(" "), _c('img', {
    staticClass: "QRcode",
    attrs: {
      "src": _vm.icon
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "discern"
  }, [_vm._v("长按识别二维码")])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71da5a38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71da5a38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/runnability.vue
// module id = 256
// module chunks = 1